function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.78,408.82c2.87-9.72,32.6-110.76,32.5-111.52s2.43-14.33,8.35-25.64,14.14-23.91,15.17-25.45a22.09,22.09,0,0,0,3.08-8.23c.77-4.11,9-15.43,11.57-18.51s10.28-19.28,10.8-21.85,3.59-4.63,7.71-5.4,9.77-1.54,9.77-1.54a7.66,7.66,0,0,1,1.8,4.37c0,2.31-9.26,57.58-9.77,66.84s.77,14.39-3.34,23.91-16.2,15.42-22.11,19.28-5.46,4.66-5.46,4.66,3.34,92.53,3.26,99.8",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.24,402.2s-23.75-43.8-27.13-51.48-5.93-19.78-6.76-23.1a22.32,22.32,0,0,1-.32-12c1.25-5.6.51-21.58,1.07-25.25s-1.71-15.15-3-21.58-4.21-11-8.15-11.5a7,7,0,0,0-6.16,2.41s-1.64-13.69-3.23-16.53-6.77-2.43-9.54-1.75-4.1,9.54-4.1,9.54-2.4-8.51-2.47-12.31-4.69-7.07-8.29-6.17-5.54,2.55-6.52,10.43.87,20.07.87,20.07l-1.87.76s-6.74-23.6-8.88-29.83-4.2-13.36-5.64-18-3.58-12-9.47-10.87-4.44,14-4.44,14,9.21,39.44,9.69,42.55,2,13.91,1.7,17.51-.29,13-.29,13l-8.77-10.46a45,45,0,0,0-4.07-8.1c-3-4.84-9.67-9.35-14-8s-.91,5.81.88,8.3,3.24,9.48,3.24,13,3,6,6.62,12.46S326,328.08,328.75,332.1a25.11,25.11,0,0,0,7.53,6.65s10.5,9.15,15.4,20.57,19.93,44.21,19.93,44.21",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.93,257.77s8.49-1.54,13.11-7.19,15.68-12.86,19.28-14.14,9.26-1.55,11.32.25,3.08,6.17,0,11.32S165,258,162.38,260.34s-4.88,3.86-8,10.8a54.43,54.43,0,0,1-12.85,17.74c-4.89,4.37-13.88,11.83-18.51,14.65",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.88,284.81c23.72-37.14,34.2-92.44,12-132.72C415.32,114.94,371,97,330.17,96c-35.32-.86-63.36,9.59-90.92,30.11-14.21,10.59-28.57,21.92-45.68,28.09-13.36,4.82-27.1,8.14-40.88,11.82-49.83,13.33-80.54,58.54-73.85,107.15C84,310.53,113,345.28,150,359.16c28.69,10.76,58.84,2.81,86.56-6.59,14.94-5.07,30-10.31,45.77-12.67,15.25-2.29,30,.57,45.1-1.08C364.64,334.76,403,317.54,423.88,284.81Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.88,284.81c23.72-37.14,34.2-92.44,12-132.72C415.32,114.94,371,97,330.17,96c-35.32-.86-63.36,9.59-90.92,30.11-14.21,10.59-28.57,21.92-45.68,28.09-13.36,4.82-27.1,8.14-40.88,11.82-49.83,13.33-80.54,58.54-73.85,107.15C84,310.53,113,345.28,150,359.16c28.69,10.76,58.84,2.81,86.56-6.59,14.94-5.07,30-10.31,45.77-12.67,15.25-2.29,30,.57,45.1-1.08C364.64,334.76,403,317.54,423.88,284.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "435.65 302.99 431.42 302.99 239.94 302.99 235.71 302.99 235.71 311.47 239.94 311.47 239.94 397.66 431.42 397.66 431.42 311.47 435.65 311.47 435.65 302.99",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.65 302.99 431.42 302.99 239.94 302.99 235.71 302.99 235.71 311.47 239.94 311.47 239.94 397.66 431.42 397.66 431.42 311.47 435.65 311.47 435.65 302.99",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07,348h52.22V320.12H245.07Zm1.06-26.85h50.1V347h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,348h52.23V320.12H309.92ZM311,321.18h50.11V347H311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.78,320.12V348H427V320.12ZM425.94,347h-50.1V321.18h50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07,385.48h52.22V357.57H245.07Zm1.06-26.85h50.1v25.79h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,385.48h52.23V357.57H309.92ZM311,358.63h50.11v25.79H311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.78,385.48H427V357.57H374.78Zm1.06-26.85h50.1v25.79h-50.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.74,
    cy: 334.43,
    rx: 8.48,
    ry: 3.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.28,
    cy: 334.43,
    rx: 8.48,
    ry: 3.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.69,
    cy: 334.43,
    rx: 8.48,
    ry: 3.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74,368.7c-4.68,0-8.48,1.42-8.48,3.18s3.8,3.17,8.48,3.17,8.48-1.42,8.48-3.17S276.42,368.7,271.74,368.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.28,368.7c-4.68,0-8.48,1.42-8.48,3.18s3.8,3.17,8.48,3.17,8.48-1.42,8.48-3.17S341,368.7,336.28,368.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,368.7c-4.68,0-8.47,1.42-8.47,3.18s3.79,3.17,8.47,3.17,8.48-1.42,8.48-3.17S407.38,368.7,402.69,368.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.18,295.58c-3.86,5.73-9.24,13.18-12.11,19.16,1.09-3.94,2.16-7.67,3.13-11,1.47-2.89,5.41-10.18,10-15,5.77-6.18,8.24-10.15,5.13-10.49-2.15-.24-8.45,8.15-12.4,16.48.86-2.85,1.54-5,2-6.29.19-.58.37-1.21.55-1.88a166.85,166.85,0,0,0,11.14-17.87c5.83-10.89,7.71-21.17,3.82-16.75-3.58,4.07-9.81,24.31-14.76,33.83.42-1.64.82-3.45,1.17-5.24.7-1.73,1.62-3.49,2.14-5.09.81-2.46,1.52-4.94,2.09-7.47a51.77,51.77,0,0,0,1.42-12,24.29,24.29,0,0,0-3.72-13.44c-.67-1-4.77-7.13-6-4a3.36,3.36,0,0,0-.09,1.61c.6,5.21,2.49,10,3.66,15.07,1.75,7.59.59,20.33,0,25.75-.22.86-.5,1.92-.83,3.15.81-9.44-3.28-20.63-7.07-22.59-4.69-2.42-.09,7.08,3.53,15.38a24.79,24.79,0,0,1,2.35,11.64c-.74,2.72-1.59,5.79-2.47,8.89-.18.42-.34.85-.5,1.27a26,26,0,0,0,.49-6.15c-.34-5.42-6.48-16.27-10.56-14.74s2.83,7.25,6.52,13.91a20.08,20.08,0,0,1,2.13,12c0,.25-.08.49-.11.72-.43,1.42-.85,2.78-1.25,4.08-1,3-1.85,5.88-2.7,8.66a43.4,43.4,0,0,0,1.36-12.36c-.51-7.94-5.16-15.44-9-16.47s3.49,11.93,5.95,19.21a26.12,26.12,0,0,1,.66,13.14c-1.19,3.94-2.31,7.83-3.46,11.94a99.51,99.51,0,0,0-.35-16.15c-.75-8.84-6-14.48-9.62-14.25s.16,5.25,5.38,16a35.91,35.91,0,0,1,3.56,18.18c-.47,1.73-1,3.51-1.44,5.37-.56,2.12-1,4.43-1.4,6.79-.52-2.11-1.3-5.19-2.21-8.59a76.13,76.13,0,0,1-2.3-11.47c-.49-4.51-1.68-10.14-6.1-12.48a2.51,2.51,0,0,0-3.71,1,5,5,0,0,0-.26,3.06,33.77,33.77,0,0,0,3,8.83,10.25,10.25,0,0,0-1.14,5.41c0,.7.06,1.4.11,2.1-.39-.72-.76-1.38-1.11-2a13.23,13.23,0,0,0-2.32-2.87,36.89,36.89,0,0,0,.34-5c0-2.19-2.57-7.78-4.89-3.64-.93,1.66-.75,4.91-.84,7.07-.63.6-.82,1.82-.29,3.74-.36,5-.43,10.12.78,15l-.8-1.39a112,112,0,0,1-2-17.54c-.29-9.73,1.26-17.71-1.39-20.71s-4.13,7.55-3,19.05a47.7,47.7,0,0,0,4.14,15.16c-2.6-4.67-5.17-9.43-7.6-14-1-2.45-3.48-9.08-2.87-15.8.77-8.47,1.33-15.41-1.89-20.18s-3.89-1.67-2.31,8.27c1.08,6.82,2.23,15.94,4.21,22.27-1.88-3.63-3.65-7.08-5.23-10.2-.9-3.12-3-11.13-3-17.78,0-8.46-.9-13-3.4-11.17-1.74,1.29-.62,11.73,2.18,20.51-1.31-2.67-2.3-4.72-2.87-5.93-.26-.55-.55-1.14-.88-1.75a167.32,167.32,0,0,0-4.05-20.66c-3.17-11.94-8.82-20.74-8.64-14.85.16,5.42,9.42,24.46,12.31,34.8-.82-1.49-1.77-3.08-2.73-4.63-.67-1.75-1.2-3.66-1.91-5.18-1.09-2.35-2.26-4.65-3.57-6.89a51.85,51.85,0,0,0-7.17-9.76A24.33,24.33,0,0,0,115,262.9c-1.18-.28-8.34-2-7.12,1.2a3.33,3.33,0,0,0,1,1.24c4,3.4,8.64,5.61,13,8.52,6.46,4.36,14.31,14.46,17.55,18.85l1.54,2.87c-5.85-7.46-16.48-12.84-20.58-11.68-5.08,1.43,4.76,5.23,13.07,8.82a24.71,24.71,0,0,1,9.66,6.91c1.32,2.5,2.79,5.31,4.26,8.18.17.43.33.85.5,1.27a26,26,0,0,0-3.83-4.83c-3.95-3.72-15.85-7.47-17.78-3.57s7,3.38,14.26,5.72a20.12,20.12,0,0,1,9.71,7.29c.14.2.27.41.41.6.66,1.32,1.28,2.61,1.87,3.83,1.36,2.87,2.66,5.56,3.93,8.17a43.35,43.35,0,0,0-7.43-10c-5.8-5.46-14.32-7.76-17.85-5.86s10.69,6.33,17.46,10a26.11,26.11,0,0,1,9.45,9.16c1.82,3.69,3.65,7.3,5.62,11.09a100.33,100.33,0,0,0-11.27-11.57c-6.59-5.95-14.28-6.49-16.77-3.85s3.7,3.73,14.84,8a35.91,35.91,0,0,1,15,10.85c.84,1.59,1.7,3.22,2.62,4.92,1,1.92,2.27,3.92,3.61,5.91-1.82-1.18-4.5-2.9-7.48-4.76a74.56,74.56,0,0,1-9.51-6.83c-3.44-2.95-8.15-6.26-13-4.95a2.49,2.49,0,0,0-2,3.26,4.88,4.88,0,0,0,1.89,2.42c4.56,3.53,10.69,5.23,16,7.32a118.38,118.38,0,0,0,14.93,4.76c1.26,1.81,2.57,3.6,3.89,5.3l-2.38.07c-2.82.09-15.54-5.68-22-7.53s-12.5,1.65-5.73,5.29,25.18,2.83,25.18,2.83l5.31-.16c1.25,1.6,2.47,3.12,3.63,4.51H155.23v7h5l4,24.89h33.53l4.05-24.89h5v-7H190.1a63.88,63.88,0,0,1,.24-9.07,21.44,21.44,0,0,1,3.69-3c7.34-5.07,19.78-5.49,23.09-15.26.8-2.35-.11-5.37-2.92-5.24-2,.09-4.17,1.87-5.43,3.32-4.2,4.85-7.36,9.88-12.82,13.56a70.71,70.71,0,0,0-5.4,4.6c.19-1.59.43-3.29.74-5.11a50.27,50.27,0,0,1,4.5-6.67c4.47-5.55,11.27-8.8,16.1-14.09,1.48-1.62,3.43-7.44-1.09-6-2,.64-4.38,3.69-6,5.08-4.45,4-9,8.26-11.9,13.52.12-.52.25-1,.37-1.56a110.66,110.66,0,0,1,10.51-14.19c6.42-7.3,13-12.08,13.11-16.08s-8.17,2.7-15.2,11.86a47.92,47.92,0,0,0-7.32,13.91c1.29-5.18,2.66-10.42,4-15.44.92-2.5,3.65-9,8.68-13.51,6.35-5.67,11.49-10.35,12.4-16S217.81,287.24,212.18,295.58ZM176.67,359.9c-.95-1.29-1.94-2.69-3-4.24a51,51,0,0,1-1.26-8,33.67,33.67,0,0,1,.32-6.87,80.69,80.69,0,0,0,5.43,6.07,30.13,30.13,0,0,1-.73,5.94A69.66,69.66,0,0,0,176.67,359.9Zm5.44,6.59c-1.29-1.37-2.7-3-4.23-5a21,21,0,0,1,.65-4.7,33.64,33.64,0,0,1,2.62-7c2.37,2.25,4.11,3.74,4.11,3.74l4,3.51c-.31,3.49-.49,6.77-.6,9.43Zm7.2-10.06-1.79-1.57c-1-.9-2.8-4.38-4.76-8.39a50.58,50.58,0,0,0,2.22-5.19c2.12,3.93,4,7,5.11,8.63C189.77,352.08,189.52,354.29,189.31,356.43Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18,295.58c-3.86,5.73-9.24,13.18-12.11,19.16,1.09-3.94,2.16-7.67,3.13-11,1.47-2.89,5.41-10.18,10-15,5.77-6.18,8.24-10.15,5.13-10.49-2.15-.24-8.45,8.15-12.4,16.48.86-2.85,1.54-5,2-6.29.19-.58.37-1.21.55-1.88a166.85,166.85,0,0,0,11.14-17.87c5.83-10.89,7.71-21.17,3.82-16.75-3.58,4.07-9.81,24.31-14.76,33.83.42-1.64.82-3.45,1.17-5.24.7-1.73,1.62-3.49,2.14-5.09.81-2.46,1.52-4.94,2.09-7.47a51.77,51.77,0,0,0,1.42-12,24.29,24.29,0,0,0-3.72-13.44c-.67-1-4.77-7.13-6-4a3.36,3.36,0,0,0-.09,1.61c.6,5.21,2.49,10,3.66,15.07,1.75,7.59.59,20.33,0,25.75-.22.86-.5,1.92-.83,3.15.81-9.44-3.28-20.63-7.07-22.59-4.69-2.42-.09,7.08,3.53,15.38a24.79,24.79,0,0,1,2.35,11.64c-.74,2.72-1.59,5.79-2.47,8.89-.18.42-.34.85-.5,1.27a26,26,0,0,0,.49-6.15c-.34-5.42-6.48-16.27-10.56-14.74s2.83,7.25,6.52,13.91a20.08,20.08,0,0,1,2.13,12c0,.25-.08.49-.11.72-.43,1.42-.85,2.78-1.25,4.08-1,3-1.85,5.88-2.7,8.66a43.4,43.4,0,0,0,1.36-12.36c-.51-7.94-5.16-15.44-9-16.47s3.49,11.93,5.95,19.21a26.12,26.12,0,0,1,.66,13.14c-1.19,3.94-2.31,7.83-3.46,11.94a99.51,99.51,0,0,0-.35-16.15c-.75-8.84-6-14.48-9.62-14.25s.16,5.25,5.38,16a35.91,35.91,0,0,1,3.56,18.18c-.47,1.73-1,3.51-1.44,5.37-.56,2.12-1,4.43-1.4,6.79-.52-2.11-1.3-5.19-2.21-8.59a76.13,76.13,0,0,1-2.3-11.47c-.49-4.51-1.68-10.14-6.1-12.48a2.51,2.51,0,0,0-3.71,1,5,5,0,0,0-.26,3.06,33.77,33.77,0,0,0,3,8.83,10.25,10.25,0,0,0-1.14,5.41c0,.7.06,1.4.11,2.1-.39-.72-.76-1.38-1.11-2a13.23,13.23,0,0,0-2.32-2.87,36.89,36.89,0,0,0,.34-5c0-2.19-2.57-7.78-4.89-3.64-.93,1.66-.75,4.91-.84,7.07-.63.6-.82,1.82-.29,3.74-.36,5-.43,10.12.78,15l-.8-1.39a112,112,0,0,1-2-17.54c-.29-9.73,1.26-17.71-1.39-20.71s-4.13,7.55-3,19.05a47.7,47.7,0,0,0,4.14,15.16c-2.6-4.67-5.17-9.43-7.6-14-1-2.45-3.48-9.08-2.87-15.8.77-8.47,1.33-15.41-1.89-20.18s-3.89-1.67-2.31,8.27c1.08,6.82,2.23,15.94,4.21,22.27-1.88-3.63-3.65-7.08-5.23-10.2-.9-3.12-3-11.13-3-17.78,0-8.46-.9-13-3.4-11.17-1.74,1.29-.62,11.73,2.18,20.51-1.31-2.67-2.3-4.72-2.87-5.93-.26-.55-.55-1.14-.88-1.75a167.32,167.32,0,0,0-4.05-20.66c-3.17-11.94-8.82-20.74-8.64-14.85.16,5.42,9.42,24.46,12.31,34.8-.82-1.49-1.77-3.08-2.73-4.63-.67-1.75-1.2-3.66-1.91-5.18-1.09-2.35-2.26-4.65-3.57-6.89a51.85,51.85,0,0,0-7.17-9.76A24.33,24.33,0,0,0,115,262.9c-1.18-.28-8.34-2-7.12,1.2a3.33,3.33,0,0,0,1,1.24c4,3.4,8.64,5.61,13,8.52,6.46,4.36,14.31,14.46,17.55,18.85l1.54,2.87c-5.85-7.46-16.48-12.84-20.58-11.68-5.08,1.43,4.76,5.23,13.07,8.82a24.71,24.71,0,0,1,9.66,6.91c1.32,2.5,2.79,5.31,4.26,8.18.17.43.33.85.5,1.27a26,26,0,0,0-3.83-4.83c-3.95-3.72-15.85-7.47-17.78-3.57s7,3.38,14.26,5.72a20.12,20.12,0,0,1,9.71,7.29c.14.2.27.41.41.6.66,1.32,1.28,2.61,1.87,3.83,1.36,2.87,2.66,5.56,3.93,8.17a43.35,43.35,0,0,0-7.43-10c-5.8-5.46-14.32-7.76-17.85-5.86s10.69,6.33,17.46,10a26.11,26.11,0,0,1,9.45,9.16c1.82,3.69,3.65,7.3,5.62,11.09a100.33,100.33,0,0,0-11.27-11.57c-6.59-5.95-14.28-6.49-16.77-3.85s3.7,3.73,14.84,8a35.91,35.91,0,0,1,15,10.85c.84,1.59,1.7,3.22,2.62,4.92,1,1.92,2.27,3.92,3.61,5.91-1.82-1.18-4.5-2.9-7.48-4.76a74.56,74.56,0,0,1-9.51-6.83c-3.44-2.95-8.15-6.26-13-4.95a2.49,2.49,0,0,0-2,3.26,4.88,4.88,0,0,0,1.89,2.42c4.56,3.53,10.69,5.23,16,7.32a118.38,118.38,0,0,0,14.93,4.76c1.26,1.81,2.57,3.6,3.89,5.3l-2.38.07c-2.82.09-15.54-5.68-22-7.53s-12.5,1.65-5.73,5.29,25.18,2.83,25.18,2.83l5.31-.16c1.25,1.6,2.47,3.12,3.63,4.51H155.23v7h5l4,24.89h33.53l4.05-24.89h5v-7H190.1a63.88,63.88,0,0,1,.24-9.07,21.44,21.44,0,0,1,3.69-3c7.34-5.07,19.78-5.49,23.09-15.26.8-2.35-.11-5.37-2.92-5.24-2,.09-4.17,1.87-5.43,3.32-4.2,4.85-7.36,9.88-12.82,13.56a70.71,70.71,0,0,0-5.4,4.6c.19-1.59.43-3.29.74-5.11a50.27,50.27,0,0,1,4.5-6.67c4.47-5.55,11.27-8.8,16.1-14.09,1.48-1.62,3.43-7.44-1.09-6-2,.64-4.38,3.69-6,5.08-4.45,4-9,8.26-11.9,13.52.12-.52.25-1,.37-1.56a110.66,110.66,0,0,1,10.51-14.19c6.42-7.3,13-12.08,13.11-16.08s-8.17,2.7-15.2,11.86a47.92,47.92,0,0,0-7.32,13.91c1.29-5.18,2.66-10.42,4-15.44.92-2.5,3.65-9,8.68-13.51,6.35-5.67,11.49-10.35,12.4-16S217.81,287.24,212.18,295.58ZM176.67,359.9c-.95-1.29-1.94-2.69-3-4.24a51,51,0,0,1-1.26-8,33.67,33.67,0,0,1,.32-6.87,80.69,80.69,0,0,0,5.43,6.07,30.13,30.13,0,0,1-.73,5.94A69.66,69.66,0,0,0,176.67,359.9Zm5.44,6.59c-1.29-1.37-2.7-3-4.23-5a21,21,0,0,1,.65-4.7,33.64,33.64,0,0,1,2.62-7c2.37,2.25,4.11,3.74,4.11,3.74l4,3.51c-.31,3.49-.49,6.77-.6,9.43Zm7.2-10.06-1.79-1.57c-1-.9-2.8-4.38-4.76-8.39a50.58,50.58,0,0,0,2.22-5.19c2.12,3.93,4,7,5.11,8.63C189.77,352.08,189.52,354.29,189.31,356.43Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frames--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.55,107.26v101.4h77V107.26Zm71.66,94.33H118.93V114.34h66.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.55,107.26v101.4h77V107.26Zm71.66,94.33H118.93V114.34h66.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,156.73v74.88h56.88V156.73Zm52.91,69.65H387V162h48.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,156.73v74.88h56.88V156.73Zm52.91,69.65H387V162h48.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.78,408.82c2.87-9.72,32.6-110.76,32.5-111.52s2.43-14.33,8.35-25.64,14.14-23.91,15.17-25.45a22.09,22.09,0,0,0,3.08-8.23c.77-4.11,9-15.43,11.57-18.51s10.28-19.28,10.8-21.85,3.59-4.63,7.71-5.4,9.77-1.54,9.77-1.54a7.66,7.66,0,0,1,1.8,4.37c0,2.31-9.26,57.58-9.77,66.84s.77,14.39-3.34,23.91-16.2,15.42-22.11,19.28-5.46,4.66-5.46,4.66,3.34,92.53,3.26,99.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-62)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.29,251.31c-1.07-4.79-8-2.13-8-2.13a46.47,46.47,0,0,1-17,11.69A206.17,206.17,0,0,0,106,275.82c1.14-2.29,2.38-4.6,3.72-7,6.91-12.22,19.13-28.69,26-30.82,4.24-1.3,8.47,1.39,11.11,3.67l.3-49.5-.17,0c-4.12.77-7.2,2.83-7.71,5.4s-8.23,18.76-10.8,21.85-10.8,14.4-11.57,18.51a22.09,22.09,0,0,1-3.08,8.23c-1,1.54-9.26,14.13-15.17,25.45s-8.45,24.87-8.35,25.64c.07.56-11.37,42-18.64,68.08,6-11.8,15.33-30.89,21-45,2.23-.22,6.55-6.26,10.13-11.18,4.25-5.84,10.62-7.44,23.38-17s27.09-22.85,29.22-28.16S163.35,256.09,162.29,251.31Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,408.82c2.87-9.72,32.6-110.76,32.5-111.52s2.43-14.33,8.35-25.64,14.14-23.91,15.17-25.45a22.09,22.09,0,0,0,3.08-8.23c.77-4.11,9-15.43,11.57-18.51s10.28-19.28,10.8-21.85,3.59-4.63,7.71-5.4,9.77-1.54,9.77-1.54a7.66,7.66,0,0,1,1.8,4.37c0,2.31-9.26,57.58-9.77,66.84s.77,14.39-3.34,23.91-16.2,15.42-22.11,19.28-5.46,4.66-5.46,4.66,3.34,92.53,3.26,99.8",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44,253.66s-2.82-.26-5.65-5.4",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,220.5s8,1.54,9,8.22",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.93,199.67A15.76,15.76,0,0,1,152.1,211",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.15,253.68l-.63-106.77a11.74,11.74,0,0,0-11.74-11.73H159.13a11.73,11.73,0,0,0-11.73,11.73l-.64,106.77a11.84,11.84,0,0,0,11.85,11.85H393.3A11.84,11.84,0,0,0,405.15,253.68Z",
    style: {
      fill: "#2e353a",
      stroke: "#363636",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.868674px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.02 259.73 391.51 140.92 160.4 140.92 159.9 259.73 392.02 259.73",
    style: {
      fill: "#fff",
      stroke: "#363636",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.651505px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.51 140.92 160.4 140.92 160.38 146.85 182.58 146.85 188.26 154.97 391.57 154.97 391.51 140.92",
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.51 164.56 229.06 259.73 392.02 259.73 391.51 164.56",
    style: {
      fill: "#92E3A9",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.99,
    cy: 200.28,
    r: 1.79,
    transform: "translate(192.57 595.64) rotate(-89.26)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.2,
    cy: 174.76,
    r: 9.57,
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.2,
    cy: 214.11,
    r: 9.57,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.6,
    cy: 174.76,
    r: 9.57,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.6,
    cy: 214.11,
    r: 9.57,
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.01,
    cy: 174.76,
    r: 9.57,
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.01,
    cy: 214.11,
    r: 9.57,
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.41,
    cy: 174.76,
    r: 9.57,
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.41,
    cy: 214.11,
    r: 9.57,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 187.72,
    x2: 226.18,
    y2: 187.72,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 194.95,
    x2: 226.18,
    y2: 194.95,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 202.19,
    x2: 226.18,
    y2: 202.19,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.34,
    y1: 187.72,
    x2: 290.69,
    y2: 187.72,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.34,
    y1: 194.95,
    x2: 290.69,
    y2: 194.95,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.34,
    y1: 202.19,
    x2: 290.69,
    y2: 202.19,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.07,
    y1: 187.72,
    x2: 359.42,
    y2: 187.72,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.07,
    y1: 194.95,
    x2: 359.42,
    y2: 194.95,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.07,
    y1: 202.19,
    x2: 359.42,
    y2: 202.19,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 228.66,
    x2: 226.18,
    y2: 228.66,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 235.9,
    x2: 226.18,
    y2: 235.9,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.83,
    y1: 243.13,
    x2: 226.18,
    y2: 243.13,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.34,
    y1: 228.66,
    x2: 290.69,
    y2: 228.66,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.34,
    y1: 235.9,
    x2: 290.69,
    y2: 235.9,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.34,
    y1: 243.13,
    x2: 290.69,
    y2: 243.13,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.07,
    y1: 228.66,
    x2: 359.42,
    y2: 228.66,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.07,
    y1: 235.9,
    x2: 359.42,
    y2: 235.9,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.07,
    y1: 243.13,
    x2: 359.42,
    y2: 243.13,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.13,
    y1: 214.6,
    x2: 296.07,
    y2: 214.6,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.64,
    y1: 202.73,
    x2: 309.64,
    y2: 195.31,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.49,
    y1: 203.58,
    x2: 300.31,
    y2: 206.55,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.16,
    y1: 222.23,
    x2: 296.49,
    y2: 224.78,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.57,
    y1: 214.6,
    x2: 323.63,
    y2: 214.6,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.2,
    y1: 203.58,
    x2: 319.39,
    y2: 206.55,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.02,
    y1: 234.26,
    x2: 310.02,
    y2: 252.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.01,
    y1: 232.11,
    x2: 302.87,
    y2: 241.4,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,402.2s-23.75-43.8-27.13-51.48-5.93-19.78-6.76-23.1a22.32,22.32,0,0,1-.32-12c1.25-5.6.51-21.58,1.07-25.25s-1.71-15.15-3-21.58-4.21-11-8.15-11.5a7,7,0,0,0-6.16,2.41s-1.64-13.69-3.23-16.53-6.77-2.43-9.54-1.75-4.1,9.54-4.1,9.54-2.4-8.51-2.47-12.31-4.69-7.07-8.29-6.17-5.54,2.55-6.52,10.43.87,20.07.87,20.07l-1.87.76s-6.74-23.6-8.88-29.83-4.2-13.36-5.64-18-3.58-12-9.47-10.87-4.44,14-4.44,14,9.21,39.44,9.69,42.55,2,13.91,1.7,17.51-.29,13-.29,13l-8.77-10.46a45,45,0,0,0-4.07-8.1c-3-4.84-9.67-9.35-14-8s-.91,5.81.88,8.3,3.24,9.48,3.24,13,3,6,6.62,12.46S326,328.08,328.75,332.1a25.11,25.11,0,0,0,7.53,6.65s10.5,9.15,15.4,20.57,19.93,44.21,19.93,44.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-62)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.28,391.78c4.91-4.5,6.13-40.85,5.51-54.38,0-.11,0-.24,0-.36-1.75-4.52-3.11-8.19-3.42-9.42a22.32,22.32,0,0,1-.32-12c1.25-5.6.51-21.58,1.07-25.25.33-2.17-.34-7.11-1.2-12.11-3.56-.31-10.08,2.9-10.08,2.9s-5.14-7.48-8.49-7.74-9.16,5-9.16,5-3.33-11.22-10.17-10.07-8.76,0-11.46.12-4.89-6.45-7.59-12.9S325.4,225,323.11,220c0,0-3.59-10.06-8.24-6.71s-.28,14.3,1.9,20.87,3.35,19.05,5.12,25c2,6.63,1,16.48,2.83,23.7s6.53,9.56,3.94,19-8.25,6.43-14.56.88-9.43-18.26-13-17a16,16,0,0,0-3.56,1.37c.08,3.46,3,6,6.62,12.32S326,328.08,328.75,332.1a25.11,25.11,0,0,0,7.53,6.65s10.5,9.15,15.4,20.57c.88,2.05,2.28,5.08,4,8.68,2,1.6-2.24-6-1.2-4.74C361.41,371.39,382.38,396.29,387.28,391.78Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,402.2s-23.75-43.8-27.13-51.48-5.93-19.78-6.76-23.1a22.32,22.32,0,0,1-.32-12c1.25-5.6.51-21.58,1.07-25.25s-1.71-15.15-3-21.58-4.21-11-8.15-11.5a7,7,0,0,0-6.16,2.41s-1.64-13.69-3.23-16.53-6.77-2.43-9.54-1.75-4.1,9.54-4.1,9.54-2.4-8.51-2.47-12.31-4.69-7.07-8.29-6.17-5.54,2.55-6.52,10.43.87,20.07.87,20.07l-1.87.76s-6.74-23.6-8.88-29.83-4.2-13.36-5.64-18-3.58-12-9.47-10.87-4.44,14-4.44,14,9.21,39.44,9.69,42.55,2,13.91,1.7,17.51-.29,13-.29,13l-8.77-10.46a45,45,0,0,0-4.07-8.1c-3-4.84-9.67-9.35-14-8s-.91,5.81.88,8.3,3.24,9.48,3.24,13,3,6,6.62,12.46S326,328.08,328.75,332.1a25.11,25.11,0,0,0,7.53,6.65s10.5,9.15,15.4,20.57,19.93,44.21,19.93,44.21",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.53,207.9s1.09,6.76,1.3,7.61c.47,1.91,8.37,1,9-.47.56-1.31.15-4.15.15-4.15",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,274.15a4.08,4.08,0,0,0,.49-5.12c-1.86-2.77-2.9-3.39-2.9-3.39",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,247.07s3.53,1.18,6.85-3.17",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.09,244s4.71-3.53,8.31-3.24",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.21,225.55s3.53-3.52,6.36-2.76",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,224.72a10.35,10.35,0,0,0,4.36-.2",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.91,
    y1: 250.99,
    x2: 357.77,
    y2: 262,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.78,
    y1: 259.73,
    x2: 374.77,
    y2: 271.29,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3,292.17s-.5,8.65.33,12",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,267.86s2.05,5.43,1.55,9",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.55,273.47s1.39,2.8.56,7.9",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.93,257.77s8.49-1.54,13.11-7.19,15.68-12.86,19.28-14.14,9.26-1.55,11.32.25,3.08,6.17,0,11.32S165,258,162.38,260.34s-4.88,3.86-8,10.8a54.43,54.43,0,0,1-12.85,17.74c-4.89,4.37-13.88,11.83-18.51,14.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-62)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.29,251.31c-1.07-4.79-8-2.13-8-2.13a46.47,46.47,0,0,1-17,11.69A206.17,206.17,0,0,0,106,275.82c1.14-2.29,2.38-4.6,3.72-7,6.91-12.22,19.13-28.69,26-30.82,4.24-1.3,8.47,1.39,11.11,3.67l.3-49.5-.17,0c-4.12.77-7.2,2.83-7.71,5.4s-8.23,18.76-10.8,21.85-10.8,14.4-11.57,18.51a22.09,22.09,0,0,1-3.08,8.23c-1,1.54-9.26,14.13-15.17,25.45s-8.45,24.87-8.35,25.64c.07.56-11.37,42-18.64,68.08,6-11.8,15.33-30.89,21-45,2.23-.22,6.55-6.26,10.13-11.18,4.25-5.84,10.62-7.44,23.38-17s27.09-22.85,29.22-28.16S163.35,256.09,162.29,251.31Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.93,257.77s8.49-1.54,13.11-7.19,15.68-12.86,19.28-14.14,9.26-1.55,11.32.25,3.08,6.17,0,11.32S165,258,162.38,260.34s-4.88,3.86-8,10.8a54.43,54.43,0,0,1-12.85,17.74c-4.89,4.37-13.88,11.83-18.51,14.65",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,246c-1.54,2.31-5.4,2.57-5.4,2.57s-1.54-3.34-2.57-5.4a9.16,9.16,0,0,0-3.34-3.34s1.29-3.34,3.86-3.34",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.25,309.92a110,110,0,0,1,28.9-2.35c16.41.79,20.31,10.16,20.31,10.16l-.78,21.09s-8.59-6.25-26.56-8.59-27.34-.78-27.34-.78Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.62,408.33l4.23-67.69c-27.34-16.41-59.07-11.19-59.07-11.19l-27,78.88Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,356.33s2.67-10.66,17.33-19.33S397,331.67,397,331.67l3.33,8.66s-18-.66-31.33,6.67-20,16-20,16Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.25,408.33l-39.56-70.72s-15-3.94-33,3.39-25.34,21.33-25.34,21.33l7.57,46Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.94,364.47c.5,2.15-.1,4.13-1.36,4.42s-2.68-1.21-3.18-3.36.1-4.13,1.35-4.42S352.43,362.32,352.94,364.47Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBro);
export default __webpack_public_path__ + "static/media/Select-bro.a8a4773e567aa4b90b9e23dd500c38d7.svg";
export { ForwardRef as ReactComponent };